<template>
  <li class="dropdown-opt" :class="classObject" @click="toggleSelect">
    <svg class="icon"><use xlink:href="#check"></use></svg>
    <span>{{ opt.title }}</span>
    <div style="display: none;">
      <input type="checkbox" :name="`${fieldName}[]`" id="categories_1" :value="opt.id" v-model="isSelected">
    </div>
  </li>
</template>

<script>
import EventBus from '../utils/event-bus';
export default {
  name: "Option",
  data() {
    return {
      isSelected: false,
    };
  },
  props: {
    opt: Object,
    optIndex: Number,
    fieldName: String
  },
  computed: {

    classObject: function () {
      return [
        'l_' + this.opt.color,
        {
        's_active' : this.isSelected
      }]
    }

  },
  methods: {

    toggleSelect(e) {
      this.isSelected = !this.isSelected;
      if (this.isSelected) {
        EventBus.$emit('OPT_SELECT', this.optIndex);
      } else {
        EventBus.$emit('OPT_DESELECT', this.optIndex);
      }
      e.preventDefault();
      return false
    },

    deSelect() {
      this.isSelected = false;
      // EventBus.$emit('OPT_DESELECT', this.optIndex);
    }

  },
  mounted() {

    // console.log(this.fieldName);

    EventBus.$on('OPT_SELECTALL', () => {

    });

    EventBus.$on('OPT_DESELECTALL', (fieldName) => {
      // console.log(this.fieldName);
      // console.log(fieldName);
      if (this.fieldName == fieldName) {
        this.deSelect();
      }
    });

  }
};
</script>

<style scoped>
</style>